import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Button,
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardMedicalFeeHistoryUX = (props: any) => {
    return(
      <div
        id="CardMedicalFeeHistoryUX-div-0"
        style={{ width : "100%", height: "100%" }}>
        <Segment
          className="segment-no-shadow"
          id="CardMedicalFeeHistoryUX-Segment-1">
          <div
            id="CardMedicalFeeHistoryUX-div-2"
            style={{display: "flex", justifyContent: "space-between", ...(props.isMeBilling && { display: "none" })}}>
            
            <div
              id="CardMedicalFeeHistoryUX-div-3"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.languageUX === "en" ? "Summary of patient medical expenses" : "สรุปค่ารักษาพยาบาลผู้ป่วย"}
            </div>
            <div
              id="CardMedicalFeeHistoryUX-div-12"
              style={{cursor: "pointer"}}>
              
            </div>
          </div>
          <div
            style={{width: "100%", ...(props.isMeBilling && { display: "none" })}}>
            
            <hr
              id="CardMedicalFeeHistoryUX-hr-6">
            </hr>
          </div>
          <div
            id="CardMedicalFeeHistoryUX-div-15">
            
            <div
              id="CardMedicalFeeHistoryUX-div-23">
              
              <Form
                className="size small"
                id="CardMedicalFeeHistoryUX-Form-24">
                <FormGroup
                  id="CardMedicalFeeHistoryUX-FormGroup-25"
                  inline={true}
                  style={{ display: "flex", alignItems: "center" }}>
                  <FormField
                    id="CardMedicalFeeHistoryUX-FormField-26"
                    inline={true}
                    style={{ ...(props.isMeBilling && { display: "none" } ) }}>
                    <Checkbox
                      checked={props.medicalFeeFilter?.isEncounterType || false}
                      id="CardMedicalFeeHistoryUX-Checkbox-32"
                      label={props.languageUX === "en" ? "Encounter type" : "ประเภท Encounter"}
                      name="isEncounterType"
                      onChange={props.onChangeFilter}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardMedicalFeeHistoryUX-FormField-27"
                    inline={true}
                    style={{ ...(props.isMeBilling && { display: "none" }) }}>
                    <Dropdown
                      className="inline-label"
                      disabled={!props.medicalFeeFilter?.isEncounterType}
                      id="CardMedicalFeeHistoryUX-Dropdown-34"
                      name="encounterType"
                      onChange={props.onChangeFilter}
                      options={props.encounterOptions}
                      selection={true}
                      value={props.medicalFeeFilter?.encounterType || ""}>
                    </Dropdown>
                  </FormField>
                  <FormField
                    style={{ flex: "1", ...(!props.isMeBilling && { display: "none" } )}}>
                  </FormField>
                  <FormField
                    id="CardMedicalFeeHistoryUX-FormField-28"
                    inline={true}>
                    <Checkbox
                      checked={props.medicalFeeFilter?.isDate|| false}
                      id="CardMedicalFeeHistoryUX-Checkbox-33"
                      label={props.languageUX === "en" ? "Encounter Opening Date" : "วันที่เปิด Encounter"}
                      name="isDate"
                      onChange={props.onChangeFilter}
                      style={{ ...(props.isMeBilling && { display: "none" }) }}>
                    </Checkbox>
                    <Checkbox
                      checked={props.medicalFeeFilter?.isDate|| false}
                      label="วันที่รับบริการ"
                      name="isDate"
                      onChange={props.onChangeFilter}
                      style={{ ...(!props.isMeBilling && { display: "none" }) }}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardMedicalFeeHistoryUX-FormField-29"
                    inline={true}>
                    <DateTextBox
                      disabled={!props.medicalFeeFilter?.isDate}
                      id="CardMedicalFeeHistoryUX-DateTextBox-35"
                      onChange={(value)=>props.onChangeFilter?.(null, {name: "startDate", value})}
                      value={props.medicalFeeFilter?.startDate|| ""}>
                    </DateTextBox>
                  </FormField>
                  <FormField
                    id="CardMedicalFeeHistoryUX-FormField-30"
                    inline={true}>
                    <DateTextBox
                      disabled={!props.medicalFeeFilter?.isDate}
                      id="CardMedicalFeeHistoryUX-DateTextBox-36"
                      onChange={(value)=>props.onChangeFilter?.(null, {name: "endDate", value})}
                      value={props.medicalFeeFilter?.endDate|| ""}>
                    </DateTextBox>
                  </FormField>
                  <FormField
                    id="CardMedicalFeeHistoryUX-FormField-31"
                    inline={true}>
                    <div
                      id="CardMedicalFeeHistoryUX-div-37">
                      {props.buttonSearch}
                    </div>
                  </FormField>
                </FormGroup>
              </Form>
            </div>
            <div
              id="CardMedicalFeeHistoryUX-div-16">
              
              <Table
                data={props.MedicalFeeHistoryList}
                getTrProps={props.getTrProps}
                headers={props.isMeBilling ? `หมายเลขบริการ,วันที่เวลารับบริการ,ผู้ให้บริการ,สิทธิการรักษา,ค่าบริการรวม,ชำระแล้ว,ค้างชำระ,ส่วนลด` : `ประเภท,เลขที่,วันที่เปิด,สิทธิการรักษา,รวม,ชำระแล้ว,ค้างชำระ,เบิกได้,ส่วนลด,สถานะ`}
                id="CardMedicalFeeHistoryUX-Table-17"
                keys={props.isMeBilling ? `number,created,serviceProvider,coverages,total,paid,unpaid,discount` : `type,number,created,coverages,total,paid,unpaid,covered,discount,status`}
                minRows="14"
                showPagination={false}
                style={{height:"calc(92dvh - 12.5rem)"}}
                widths={props.isMeBilling ? `120,170,150,,120,90,90,90` : `100,100,170,,120,90,90,90,90,150`}>
              </Table>
            </div>
          </div>
          <div
            id="CardMedicalFeeHistoryUX-div-18"
            style={{display:"flex",marginTop:"10px"}}>
            
            <Button
              icon="redo"
              id="CardMedicalFeeHistoryUX-Button-22"
              onClick={props.onRefresh}>
            </Button>
            <div
              id="CardMedicalFeeHistoryUX-div-21"
              style={{flex:"1"}}>
              
            </div>
            <div
              id="CardMedicalFeeHistoryUX-div-38"
              style={{marginRight:"5px"}}>
              {props.buttonDetail}
            </div>
            <div
              id="CardMedicalFeeHistoryUX-div-19"
              style={{marginRight:"5px"}}>
              {props.buttonPrint}
            </div>
            <Button
              color="yellow"
              disabled={props.selectedRow ? false : true}
              id="CardMedicalFeeHistory-Button-EditDiscount"
              onClick={props.onEdit}
              style={{   display: props.hideButtonEdit || (!props.hideButtonEdit && props.isMeBilling)     ? "none"     : undefined }}>
              {props.languageUX === "en" ? "Edit discount rights" : "แก้ไขสิทธิส่วนลด"}
            </Button>
            <Button
              disabled={props.selectedRow ? false : true}
              onClick={props.onEdit}
              style={{  background: "var(--primary-theme-color)", color: "white", display: props.hideButtonEdit || (!props.hideButtonEdit && !props.isMeBilling)     ? "none"     : undefined }}>
              ส่วนลด
            </Button>
          </div>
        </Segment>
      </div>
    )
}


export default CardMedicalFeeHistoryUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Thu Jan 15 2026 12:59:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "segment-no-shadow"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", ...(props.isMeBilling && { display: \"none\" })}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "สรุปค่ารักษาพยาบาลผู้ป่วย",
          "valueEN": "Summary of patient medical expenses"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-15"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-16"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 17,
      "name": "Table",
      "parent": 16,
      "props": {
        "columns": {
          "type": "code",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.MedicalFeeHistoryList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "code",
          "value": "props.isMeBilling ? `หมายเลขบริการ,วันที่เวลารับบริการ,ผู้ให้บริการ,สิทธิการรักษา,ค่าบริการรวม,ชำระแล้ว,ค้างชำระ,ส่วนลด` : `ประเภท,เลขที่,วันที่เปิด,สิทธิการรักษา,รวม,ชำระแล้ว,ค้างชำระ,เบิกได้,ส่วนลด,สถานะ`"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-Table-17"
        },
        "keys": {
          "type": "code",
          "value": "props.isMeBilling ? `number,created,serviceProvider,coverages,total,paid,unpaid,discount` : `type,number,created,coverages,total,paid,unpaid,covered,discount,status`"
        },
        "minRows": {
          "type": "value",
          "value": "14"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height:\"calc(92dvh - 12.5rem)\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.isMeBilling ? `120,170,150,,120,90,90,90` : `100,100,170,,120,90,90,90,90,150`"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",marginTop:\"10px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Button",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขสิทธิส่วนลด",
          "valueEN": "Edit discount rights"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "disabled": {
          "type": "code",
          "value": "props.selectedRow ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistory-Button-EditDiscount"
        },
        "onClick": {
          "type": "code",
          "value": "props.onEdit"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{   display: props.hideButtonEdit || (!props.hideButtonEdit && props.isMeBilling)     ? \"none\"     : undefined }"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Button",
      "parent": 18,
      "props": {
        "icon": {
          "type": "value",
          "value": "redo"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-Button-22"
        },
        "onClick": {
          "type": "code",
          "value": "props.onRefresh"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-23"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Form",
      "parent": 23,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-Form-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormGroup",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-FormGroup-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isMeBilling && { display: \"none\" } ) }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isMeBilling && { display: \"none\" }) }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 25,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Checkbox",
      "parent": 26,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.medicalFeeFilter?.isEncounterType || false"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-Checkbox-32"
        },
        "label": {
          "type": "value",
          "value": "ประเภท Encounter",
          "valueEN": "Encounter type"
        },
        "name": {
          "type": "value",
          "value": "isEncounterType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Checkbox",
      "parent": 28,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.medicalFeeFilter?.isDate|| false"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-Checkbox-33"
        },
        "label": {
          "type": "value",
          "value": "วันที่เปิด Encounter",
          "valueEN": "Encounter Opening Date"
        },
        "name": {
          "type": "value",
          "value": "isDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.isMeBilling && { display: \"none\" }) }"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Dropdown",
      "parent": 27,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.medicalFeeFilter?.isEncounterType"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-Dropdown-34"
        },
        "name": {
          "type": "value",
          "value": "encounterType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.encounterOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.medicalFeeFilter?.encounterType || \"\""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 35,
      "name": "DateTextBox",
      "parent": 29,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.medicalFeeFilter?.isDate"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-DateTextBox-35"
        },
        "onChange": {
          "type": "code",
          "value": "(value)=>props.onChangeFilter?.(null, {name: \"startDate\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.medicalFeeFilter?.startDate|| \"\""
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 36,
      "name": "DateTextBox",
      "parent": 30,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.medicalFeeFilter?.isDate"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-DateTextBox-36"
        },
        "onChange": {
          "type": "code",
          "value": "(value)=>props.onChangeFilter?.(null, {name: \"endDate\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.medicalFeeFilter?.endDate|| \"\""
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-37"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonDetail"
        },
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", ...(props.isMeBilling && { display: \"none\" })}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "hr",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardMedicalFeeHistoryUX-hr-6"
        }
      },
      "seq": 41,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 25,
      "props": {
        "style": {
          "type": "code",
          "value": "{ flex: \"1\", ...(!props.isMeBilling && { display: \"none\" } )}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Checkbox",
      "parent": 28,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.medicalFeeFilter?.isDate|| false"
        },
        "label": {
          "type": "value",
          "value": "วันที่รับบริการ"
        },
        "name": {
          "type": "value",
          "value": "isDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.isMeBilling && { display: \"none\" }) }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Button",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด"
        },
        "disabled": {
          "type": "code",
          "value": "props.selectedRow ? false : true"
        },
        "onClick": {
          "type": "code",
          "value": "props.onEdit"
        },
        "style": {
          "type": "code",
          "value": "{  background: \"var(--primary-theme-color)\", color: \"white\", display: props.hideButtonEdit || (!props.hideButtonEdit && !props.isMeBilling)     ? \"none\"     : undefined }"
        }
      },
      "seq": 44,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardMedicalFeeHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
